import { Crown, Sparkles } from 'lucide-react';

type Tier = 'starter' | 'pro';

interface TierBadgeProps {
  tier: Tier;
  size?: 'sm' | 'md';
}

export function TierBadge({ tier, size = 'sm' }: TierBadgeProps) {
  const sizeClasses = size === 'sm'
    ? 'px-1.5 py-0.5 text-[10px]'
    : 'px-2 py-1 text-xs';

  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

  if (tier === 'pro') {
    return (
      <span className={`inline-flex items-center gap-1 ${sizeClasses} rounded font-semibold bg-purple-500/20 text-purple-400 border border-purple-500/30`}>
        <Crown className={iconSize} />
        PRO
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 ${sizeClasses} rounded font-semibold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30`}>
      <Sparkles className={iconSize} />
      STARTER
    </span>
  );
}

// Shorthand component for PRO badge
export function ProBadge({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  return <TierBadge tier="pro" size={size} />;
}

// Shorthand component for STARTER badge
export function StarterBadge({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  return <TierBadge tier="starter" size={size} />;
}
